import {
  getSessionRealm,
  getUserAccessToken,
  getUserIdToken,
  hasAuthTokens,
  setSessionRealm,
} from 'services/auth';

function hasUserBearerToken(): boolean {
  const idToken = getUserIdToken();
  if (typeof idToken === 'string' && idToken.trim().length > 0) {
    return true;
  }

  const accessToken = getUserAccessToken();
  return typeof accessToken === 'string' && accessToken.trim().length > 0;
}

export function isAdminAuthenticated(): boolean {
  const realm = getSessionRealm();
  if (realm === 'user') {
    return false;
  }

  const hasAdminTokens = hasAuthTokens();
  if (!hasAdminTokens) {
    return false;
  }

  if (realm == null) {
    setSessionRealm('admin');
  }

  return true;
}

export function isUserAuthenticated(): boolean {
  const realm = getSessionRealm();
  if (realm === 'admin') {
    return false;
  }

  const isAuthenticated = hasUserBearerToken();
  if (!isAuthenticated) {
    return false;
  }

  if (realm == null) {
    setSessionRealm('user');
  }

  return true;
}
